export default __webpack_public_path__ + "static/media/g2.c552b45e.jpg";